export default __webpack_public_path__ + "static/media/KSA.2e81085d.svg";